import { Environment } from "../app/models/Environement";

export const environment: Environment = {
  production: false,
  apiURL: 'https://api-integration.maelyse-aurelien-2027.fr'
};